export default
    {
        path: '/search',
        component: require('./index').default,
        parent: 'root',
        meta:{
            title:'搜索结果',
        }
    }
